import { render, staticRenderFns } from "./AvanzadaSignFirmadorministerioeconomia.vue?vue&type=template&id=5fd3d0c4&scoped=true&"
import script from "./AvanzadaSignFirmadorministerioeconomia.vue?vue&type=script&lang=js&"
export * from "./AvanzadaSignFirmadorministerioeconomia.vue?vue&type=script&lang=js&"
import style0 from "./AvanzadaSignFirmadorministerioeconomia.vue?vue&type=style&index=0&id=5fd3d0c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd3d0c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fd3d0c4')) {
      api.createRecord('5fd3d0c4', component.options)
    } else {
      api.reload('5fd3d0c4', component.options)
    }
    module.hot.accept("./AvanzadaSignFirmadorministerioeconomia.vue?vue&type=template&id=5fd3d0c4&scoped=true&", function () {
      api.rerender('5fd3d0c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/advanced/ministerioEconomia/AvanzadaSignFirmadorministerioeconomia.vue"
export default component.exports